import { CompassCardUI } from '@scale/compass-ui/types';
import {
  VellumCardShared,
  VellumSchemaType,
  VellumContext,
  VELLUM,
} from '@scale/genai-compass-shared/cards/vellum';
import VellumCardComponent from './VellumCardComponent';
import { faCoffee } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: VellumContext = {
  cardType: VELLUM,
  productId: undefined,
  optionSelections: {},
  orderDate: '',
  sfOfficeConfirmation: false,
};

export const VellumCardInfo: CompassCardUI<VellumSchemaType> = {
  ...VellumCardShared,
  title: 'Vellum Order Processing',
  icon: 'coffee',
  toolTip: 'Process food orders through the Vellum service for employee meal management',
  defaultContext,
  isAdvanced: true,
  button: {
    icon: faCoffee,
  },
  legacyComponent: VellumCardComponent,
};
